export function isMobileDisplay() {
    return window.innerWidth <= 960;
}
// If the browser supports grid layout, it's probably ok
export default function isSupported() {
    var _a, _b;
    return (_b = (_a = window.CSS) === null || _a === void 0 ? void 0 : _a.supports('( display: grid )')) !== null && _b !== void 0 ? _b : false;
}
